import PropTypes from 'prop-types'
import styles from './Estrellas.module.css'

const ESTRELLAS_2 = 2
const ESTRELLAS_3 = 3
const ESTRELLAS_4 = 4
const ESTRELLAS_5 = 5

export const Estrellas = ({ calificacion = 0, handleStarClick }) => {
  return (
    <div className={styles.rating}>
      {[1, ESTRELLAS_2, ESTRELLAS_3, ESTRELLAS_4, ESTRELLAS_5].map((estrella) => (
        <button
          key={estrella}
          type="button"
          className={`${styles.estrella} ${calificacion >= estrella ? styles.estrellaActiva : ''}`}
          onClick={() => handleStarClick(estrella)}
          aria-label={`${estrella} estrella${estrella > 1 ? 's' : ''}`}
          aria-pressed={calificacion >= estrella}
        >
          <i className="fa fa-star" aria-hidden="true"></i>
        </button>
      ))}
    </div>
  )
}

Estrellas.propTypes = {
  calificacion: PropTypes.number,
  handleStarClick: PropTypes.func.isRequired
}
